// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Статус',
        isSortable: true,
        sortName: 'partner_status.name',
        dispatchName: 'contractorListPage/getContractorsSort'
      },
      {
        title: 'Краткое наименование',
        isSortable: true,
        sortName: 'short_name',
        dispatchName: 'contractorListPage/getContractorsSort'
      },
      {
        title: 'Юридический адрес',
        isSortable: false
      },
      {
        title: 'ИНН',
        isSortable: false
      },
      {
        title: 'Дата создания',
        isSortable: true,
        sortName: 'created_at',
        dispatchName: 'contractorListPage/getContractorsSort'
      },
      {
        title: 'Контактное лицо',
        isSortable: true,
        sortName: 'contact_fullname',
        dispatchName: 'contractorListPage/getContractorsSort'
      },
      {
        title: 'Должность',
        isSortable: true,
        sortName: 'contact_position',
        dispatchName: 'contractorListPage/getContractorsSort'

      },
      {
        title: 'Тип контрагента',
        isSortable: true,
        sortName: 'partner_type.name',
        dispatchName: 'contractorListPage/getContractorsSort'
      }
    ]
  },
  contractors: [
    {
      id: 1,
      isControlsActive: false,
      isActive: false,
      status: '',
      name: '',
      registrationAddress: '',
      inn: '',
      created_at: '',
      contactInfo: '',
      type: ''
    }
  ],
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  sort: {},
  filter: {},
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  isActiveDelete: false
})

const getters = {
  getContractorsList: state => state.contractors,
  getContractorsListTableHeaders: state => state.tableHeaders,
  getContractorsListSearchValue: state => state.searchValue,
  getContractorsListFilter: state => state.filter,
  getContractorsListPagination: state => state.pagination,
  getContractorsListIsLoading: state => state.isLoading,
  getContractorsListResponseModal: state => state.responseModal,
  getContractorsListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTORS: (state, contractors) => {
    state.contractors = contractors.map((contractor) => {
      return {
        ...contractor,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTORS_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.contractors.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  TOGGLE_CONTRACTORS_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.contractors.length
    let counter = 0

    state.contractors.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTORS_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.contractors.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_CONTRACTORS_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.contractors.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // pagination
  SET_CONTRACTORS_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    state.pagination.currentTage = Number(headers['x-pagination-per-page'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTORS_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },
  SET_CURRENT_PAGE: (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  // search
  SET_CONTRACTORS_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // sort
  SET_CONTRACTORS_LIST_SORT: (state, sortOptions) => {
    state.sort = sortOptions
  },

  // filter
  TOGGLE_CONTRACTORS_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },

  // filter
  SET_CONTRACTOR_LIST_FILTER: (state, filter) => {
    state.filter = filter
  },

  // delete checked items
  DELETE_CONTRACTORS_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили контрагент(ов)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTORS_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems
    errorItems.forEach(e => {
      listNamesErrorItems = listNamesErrorItems + ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении контрагента произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },
  CLOSE_DELETE_CONTRACTORS_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },

  // reset store
  RESET_CONTRACTORS_LIST_STORE: (state) => {
    state.searchValue = ''
    state.sort = {}
    state.filter = {}
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractors ({ commit, state }) {
    const params = {
      expand: 'status,name,registrationAddress,inn,created_at,contactInfo,type',
      sort: (state.sort.descending ? '-' : '') + (state.sort.name || 'id'),
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      'search[all]': state.searchValue || null
    }

    for (const key in state.filter) {
      if (state.filter[key]) {
        params[`search[${key}]`] = state.filter[key]
      }
    }

    axios.get(`${url}/partner`, { params, ...config }).then(response => {
      commit('GET_CONTRACTORS', response.data.data)
      commit('SET_CONTRACTORS_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  toggleContractorsListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractorsListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractorsListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTORS_LIST_ITEM_ACTIVE_ALL')
  },

  // pagination
  getContractorsListPage ({ commit, dispatch }, pageNum) {
    commit('SET_CURRENT_PAGE', pageNum)
    dispatch('getContractors')
  },
  resetContractorsListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTORS_LIST_CURRENT_PAGE')
  },

  // search
  setContractorsListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTORS_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTORS_LIST_CURRENT_PAGE')
    dispatch('getContractors')
  },

  toggleTaskListTableItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTORS_LIST_ITEM_CONTROLS', itemId)
  },
  removeContractorItem ({ dispatch }, itemId) {
    axios.delete(`${url}/partner/${itemId}`, config).then(response => {
      dispatch('getContractors')
    }).catch(error => {
      console.log('Ошибка удаления контрагента:' + error)
    })
  },

  // sort
  getContractorsSort ({ commit, dispatch }, sort) {
    commit('SET_CONTRACTORS_LIST_SORT', sort)
    dispatch('getContractors')
  },

  // delete checked items
  deleteContractorsListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    state.contractors.forEach((e) => {
      if (e.isActive) {
        checkedItems.push(e)
      }
    })

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/partner/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления контрагента', error)
        })
      }
    }
    processMessages(checkedItems).then(() => {
      if (errorItems.length > 0) {
        commit('RESET_CONTRACTORS_LIST_ALL_CHECKS')
        commit('DELETE_CONTRACTORS_LIST_CHECKED_ITEMS_ERROR', errorItems)
        dispatch('getContractors')
      } else {
        commit('RESET_CONTRACTORS_LIST_ALL_CHECKS')
        commit('DELETE_CONTRACTORS_LIST_CHECKED_ITEMS_SUCCESS')
        dispatch('getContractors')
      }
    })
  },
  closeContractorsListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTORS_LIST_MODAL')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
